import { MajorMilestoneBase } from './base/major-milestone-base';

export class MajorMilestone extends MajorMilestoneBase { }